import {Clients} from '@/api/clients'
import {Mailing} from '@/api/mailing'

import {
  GET_CLIENT,
  UPDATE_CLIENT,
  GET_CLIENTS,

  UPDATE_USER_PAYMENT,
  // GET_GENERAL_SETTINGS,
  // PUT_GENERAL_SETTINGS,
  //
  // SET_MANAGER_CURRENT_CLIENT,
  // GET_USER_INFO,

  GET_MAILING_TEMPLATES,
} from './types/index'

const state = {
  clientsArr: [],
  currentClient: {},
  mailingTemplates: {}
}

const getters = {}

const mutations = {
  [GET_CLIENT] (state, payload) {
    state.taxPaymentsArr = payload
    state.currentClient = payload
  },
  [UPDATE_CLIENT] (state, payload) {
    state.currentClient = payload
  },
  [GET_CLIENTS] (state, payload) {
    state.clientsArr = payload
  },
  [UPDATE_USER_PAYMENT] (state, payload) {
    state.targetPayments = payload
  },
  [GET_MAILING_TEMPLATES] (state, payload) {
    state.mailingTemplates = payload
  }
}

const actions = {
  [GET_CLIENT] ({commit}, {userId}) {
    console.log(userId)
    return Clients[GET_CLIENT](userId)
      .then((result) => {
        commit(GET_CLIENT, result)
      })
  },
  [UPDATE_CLIENT] ({commit}, {client, userId}) {
    return Clients[UPDATE_CLIENT](client, userId)
      .then((result) => {
        console.log(result)
        commit(UPDATE_CLIENT, result)
      })
  },
  [GET_CLIENTS] ({commit}) {
    return Clients[GET_CLIENTS]()
      .then((result) => {
        commit(GET_CLIENTS, result)
      })
  },
  // [UPDATE_USER_PAYMENT] ({commit}, {editedPayment, type, client_id}) {
  //   console.log(type)
  //   return Payments[UPDATE_USER_PAYMENT](editedPayment, type, client_id)
  //     .then((result) => {
  //       commit(UPDATE_USER_PAYMENT, result)
  //     })
  // },
  // [GET_GENERAL_SETTINGS] ({commit}) {
  //   return Payments[GET_GENERAL_SETTINGS]()
  //     .then((result) => {
  //       commit(GET_GENERAL_SETTINGS, result)
  //     })
  // },
  // [PUT_GENERAL_SETTINGS] ({commit}, {generalSettings}) {
  //   return Payments[PUT_GENERAL_SETTINGS](generalSettings)
  // },
  //
  // [SET_MANAGER_CURRENT_CLIENT] ({commit}, {client}) {
  //   state.currentClient = client
  // },
  // [GET_USER_INFO] ({commit}, {userId}) {
  // },
  [GET_MAILING_TEMPLATES] ({commit}) {
    return Mailing[GET_MAILING_TEMPLATES]()
      .then((result) => {
        commit(GET_MAILING_TEMPLATES, result)
      })
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
